import React, { useState, useEffect, useContext } from 'react'
import {
    ListBox,
    ListBoxToolbar,
    processListBoxData
} from '@progress/kendo-react-listbox';
// * Helpers
import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';
import AuthContext from '../../context/Auth/AuthContext';
import { useTranslation } from 'react-i18next';
import API from "../../services/api";
// Constants
import { TRANSFER_TO, TRANSFER_FROM } from './constants'
import { VIEW } from '../../assets/Constants/actionsTypes';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { ImArrowRight, ImArrowLeft } from 'react-icons/im'

const SELECTED_FIELD = "selected";

const Step2 = (props) => {
    // we call the hook to make translations
    const { t } = useTranslation('common');
    // ListBox components state
    const [state, setState] = React.useState({
        availableBenefits: [],
        addedBenefits: []
    });
    // Selected benefit id state
    // Used to sent to save or delete
    const [selectedBenefitId, setSelectedBenefitId] = useState(0)

    // Session context to get the current institution data
    const { get_currentInstitution } = useContext(AuthContext);

    // we use useEffect to call the function that returns the step2 data
    useEffect(() => {
        if (props.activeStep === 2) {
            getStep2_data();
        }
    }, [props.activeStep]); // eslint-disable-line react-hooks/exhaustive-deps

    // Calls the API to get the list of available benefits
    const getStep2_data = async () => {
        try {
            // Gets the data from each of the lists, they are all fetched at once 
            // to avoid losing data for different setSate in different functions.
            const responseAvailable = await API.get(`/model/step2AvailableBenefits?institutionId=${get_currentInstitution().catInstitutionId}&modelId=${props.modelData.modelid}`);
            const responseAdded = await API.get(`/model/step2AddedBenefits?institutionId=${get_currentInstitution().catInstitutionId}&modelId=${props.modelData.modelid}`);
            // if error in request
            if (responseAvailable.data.code !== 100 || responseAdded.data.code !== 100) {
                Notifications.notify(responseAvailable.data.msg, ERROR_NOTIFICATION);
                return;
            } else {


                const availableBenefitsBD = responseAvailable.data.data;

                const availableBenefitsFirstSelected = availableBenefitsBD.map((item, i) => {
                    if (i === 0) {
                        item[SELECTED_FIELD] = true;
                    } else {
                        item[SELECTED_FIELD] = false;
                    }

                    return item;
                });

                setState({
                    ...state,
                    availableBenefits: availableBenefitsFirstSelected,
                    addedBenefits: responseAdded.data.data
                });

                if (availableBenefitsBD.length !== 0) {
                    setSelectedBenefitId(availableBenefitsBD[0].benefitId)
                }
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    // * This function is called when the PREVIOUS arrow is clicked.
    // * It is passed as parameter to each step 
    const onPreviousClick = () => {
        props.changeStep(1);
    }

    // * This function is called when the NEXT arrow is clicked.
    // * It is passed as parameter to each step 
    const onNextClick = () => {
        // You cannot proceed to the next step if you have not selected at least one benefit.
        if (state.addedBenefits === [] || state.addedBenefits.length <= 0) {
            Notifications.notify(t('model.noSelectedBenefit'), ERROR_NOTIFICATION);
            return;
        } else {
            props.changeStep(3);
        }
    }

    // * Sets the active item after click
    const handleItemClick = (event, data, connectedData) => {
        setState({
            ...state,
            [data]: state[data].map((item) => {
                if (item.name === event.dataItem.name) {
                    item[SELECTED_FIELD] = !item[SELECTED_FIELD];
                } else {
                    item[SELECTED_FIELD] = false;
                }

                return item;
            }),
            [connectedData]: state[connectedData].map((item) => {
                item[SELECTED_FIELD] = false;
                return item;
            }),
        });
        setSelectedBenefitId(event.dataItem.benefitId)
    };

    // * Function to arrows
    const handleToolBarClick = async (e) => {
        let toolName = e.toolName || "";
        let result = processListBoxData(
            state.availableBenefits,
            state.addedBenefits,
            toolName,
            SELECTED_FIELD
        );

        // click in arrow 
        let responseSave = await arrowAction(toolName)

        if (responseSave) {
            // Updates the state
            setState({
                ...state,
                availableBenefits: result.listBoxOneData,
                addedBenefits: result.listBoxTwoData,
            });
        }
    };

    // if TRANSFER_TO the benefit is saved in the model
    // if TRANSFER_FROM the benefit is removed from the model
    const arrowAction = async (toolName) => {
        try {
            if (toolName === TRANSFER_TO) {
                // calls the API to save the benefit
                const response = await API.post(`/model/step2InsertBenefit?modelId=${props.modelData.modelid}&benefitId=${selectedBenefitId}`);
                // Message
                if (response.data.code !== 100) {
                    Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                    return false;
                } else {
                    Notifications.notify(t('model.benefitAdded'), SUCCESS_NOTIFICATION);
                    return true;
                }
            } else {
                // calls the API to remove the benefit
                const response = await API.delete(`/model/step2DeleteBenefit?modelId=${props.modelData.modelid}&benefitId=${selectedBenefitId}`);

                // Message
                if (response.data.code !== 100) {
                    if (response.data.code === 300002) {
                        Notifications.notify(t('model.invalidBenefitDelete'), ERROR_NOTIFICATION);
                        return false;
                    } else {
                        Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                        return false;
                    }
                } else {
                    Notifications.notify(t('model.benefitRemoved'), SUCCESS_NOTIFICATION);
                    return true;
                }
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    // const CustomListBoxBenefitItem = (props) => {
    //     // Customization of listbox item rendering
    //     // Currently this is not changing anything... it is just an example if needed.
    //     // Ref.: [Kendo React UI - ListBox - Customization](https://www.telerik.com/kendo-react-ui/components/listbox/customization/)
    //     let { dataItem, selected, ...others } = props;
    //     return (
    //       <li {...others}>{props.dataItem.name}</li>
    //     );
    //   };

    return (
        <div className="col-md-12">
            <div className="row">
                <h6>{t('model.step2_desc')}</h6>
            </div>
            <div className="row row_attrs container_steps">
                <div className="col-sm-8">
                    <div className="form-row">
                        <div className="form-group col-md-6" style={{ textAlign: "center" }}>
                            <label className="ilo_lbl_general" style={{ fontWeight: "bold" }}>{t('model.allBenefits_title')}</label>
                            <ListBox
                                style={{
                                    height: 350,
                                    width: "100%",
                                    textAlign: "left"
                                }}
                                data={state.availableBenefits}
                                // item={CustomListBoxBenefitItem}
                                textField="name"
                                selectedField={SELECTED_FIELD}
                                onItemClick={(e) => handleItemClick(e, "availableBenefits", "addedBenefits")}
                                toolbar={() => {
                                    return (
                                        <ListBoxToolbar
                                            tools={props.isEditMode ? [
                                                TRANSFER_TO,
                                                TRANSFER_FROM
                                            ] : null}
                                            data={state.availableBenefits}
                                            dataConnected={state.addedBenefits}
                                            onToolClick={handleToolBarClick}
                                        />
                                    );
                                }}
                            />
                        </div>
                        <div className="form-group col-md-6" style={{ textAlign: "center" }}>
                            <label className="ilo_lbl_general" style={{ fontWeight: "bold" }}>{t('model.modelBenefits_title')}</label>
                            <ListBox
                                style={{
                                    height: 350,
                                    width: "100%",
                                    textAlign: "left"
                                }}
                                data={state.addedBenefits}
                                textField="name"
                                selectedField={SELECTED_FIELD}
                                onItemClick={(e) => handleItemClick(e, "addedBenefits", "availableBenefits")}
                            />
                        </div>
                    </div>
                    {props.isEditMode ?
                        <small className="buttons_alert_text"><span className="asterisk_color"> * </span> {t('model.wizard_addRemove_alert')}</small>
                        :
                        <></>
                    }
                </div>
                <div className="col-sm-4"></div>
            </div>
            <div className="row arrows_position">
                <div className="col-sm-12">
                    <button className="btn_style" type="button" onClick={() => { onPreviousClick(); }} ><ImArrowLeft /></button>
                    {props.isActionView === VIEW ? null : !props.isEditMode ? (
                        <button
                            onClick={() => { props.editSteps(); }}
                            className="btn btn-primary ilo-btn"
                            style={{ marginBottom: "10px", marginRight: "3px" }}
                        >
                            {t('model.step7_edit_btn')}
                        </button>
                    ) : null
                    }
                    <button className="btn_style" type="button" onClick={() => { onNextClick(); }} ><ImArrowRight /></button>
                </div>
            </div>
        </div>
    );
}

export default Step2